import React from 'react';
import { Modal } from '../common';
import { StoryViewer } from './StoryViewer';
import { useAllPassages } from '../../hooks/usePassages';

export const StoryModal = ({ isOpen, onClose, gameId }) => {
  const { data, isLoading } = useAllPassages(gameId);
  const passageCount = data?.passages?.length || 0;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Story" size="xl">
      <div className="max-h-[70vh] overflow-y-auto">
        {isLoading ? (
          <div className="text-center py-8 text-gray-500">Loading story...</div>
        ) : passageCount === 0 ? (
          <div className="text-center py-8 text-gray-500">
            No passages written yet. The story will appear here once the first round is completed.
          </div>
        ) : (
          <StoryViewer gameId={gameId} />
        )}
      </div>
    </Modal>
  );
};
